import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { getMapUrl } from 'app/shared/utils/getMapUrl';
import { Box, Typography } from 'app/shared/components/atoms';
import { NavigationLink as Link } from 'app/shared/components/atoms';

interface AddressLinkProps {
  venueAddress?: string;
  eventStartsAt: string;
}

function eventStartsInMoreThan36Hours(eventStartsAt: string) {
  const THIRTY_SIX_HOURS = 60 * 60 * 36 * 1000;
  const startDate = new Date(eventStartsAt).getTime();
  const currentDate = new Date().getTime();

  return startDate - currentDate > THIRTY_SIX_HOURS;
}

export const AddressLink: React.FC<
  React.PropsWithChildren<AddressLinkProps>
> = ({ venueAddress, eventStartsAt, ...props }) => {
  const { formatMessage } = useIntl();
  const { colors } = useCurrentTheme();

  if (eventStartsInMoreThan36Hours(eventStartsAt) || !venueAddress) {
    return (
      <>
        <Box {...props} mt={1}>
          <Typography
            color={colors.primary.white.base}
            display="inline"
            fontStyle="italic"
            fontSize="fontSize300"
          >
            {formatMessage({ id: 'event.eventDetails.addressReveal' })}
          </Typography>
        </Box>
        <Box mt={3}>
          <Typography
            color={colors.primary.white.base}
            display="inline"
            fontStyle="italic"
            fontSize="fontSize300"
          >
            {formatMessage({ id: 'event.eventDetails.arrivalDisclaimer' })}
          </Typography>
        </Box>
      </>
    );
  }

  return (
    <Box mt={1}>
      <Typography
        color={colors.primary.white.base}
        fontWeight="medium"
        display="inline"
        fontStyle="italic"
      >
        {formatMessage({ id: 'event.eventDetails.address' })}
      </Typography>
      <Link
        href={getMapUrl(venueAddress)}
        openInNewTab={true}
        variant="primary"
      >
        {venueAddress}
      </Link>
    </Box>
  );
};
